// Elements
// const switcher = document.getElementById("langSwitcher")
const curSwitchDesktop = document.getElementById("curLang-desktop")
const curSwitchMob = document.getElementById("curLang-mobile")

const linkTranslationDesktop = document.getElementById("lang2-desktop")
const linkTranslationMob = document.getElementById("lang2-mobile")

const curPathArray = window.location.pathname.split('/')
curPathArray.shift()

if (!localStorage.getItem('currentLang')) {
 if (curPathArray[0] == 'en') {
  // Init & save current + alt lang
  localStorage.setItem('currentLang', 'en')
  localStorage.setItem('altLang', 'fr')
 } else {
  localStorage.setItem('currentLang', 'fr')
  localStorage.setItem('altLang', 'en')
 }
}

// Define alt link to translation
let altURL = ''
if (curPathArray[0] == 'en') {
 curPathArray.shift()
 altURL = `/${curPathArray.join('/')}`

 localStorage.setItem('currentLang', 'en')
 localStorage.setItem('altLang', 'fr')
} else {
 altURL = `/${localStorage.getItem('altLang')}/${curPathArray.join('/')}`
 localStorage.setItem('currentLang', 'fr')
 localStorage.setItem('altLang', 'en')
}

// On page load
curSwitchDesktop.innerText = localStorage.getItem('currentLang')
curSwitchMob.innerText = localStorage.getItem('currentLang')

/* Desktop links */
linkTranslationDesktop.setAttribute("href", altURL)
linkTranslationDesktop.innerText = localStorage.getItem('altLang')

/* Mobile links */
linkTranslationMob.setAttribute("href", altURL)
linkTranslationMob.innerText = localStorage.getItem('altLang')

// Event Listener Lang Switcher - Desktop
linkTranslationDesktop.addEventListener("click", e => {
 let curLang = localStorage.getItem("currentLang")
 localStorage.setItem("currentLang", localStorage.getItem("altLang"))
 localStorage.setItem("altLang", curLang)
})

// Event Listener Lang Switcher - Mobile
linkTranslationMob.addEventListener("click", e => {
 let curLang = localStorage.getItem("currentLang")
 localStorage.setItem("currentLang", localStorage.getItem("altLang"))
 localStorage.setItem("altLang", curLang)
})
